import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LOCAL_STORAGE_PENDING_RELOAD_KEY } from '../constants';
import { healthServiceApiRef } from '../../../core/apis';
import { alertApiRef, useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';

export const useVersionCheck = (
  reloadPage = () => window.location.reload(),
) => {
  const location = useLocation();
  const [isAlertPosted, setIsAlertPosted] = useState(false);
  const alerts = useApi(alertApiRef);
  const health = useApi(healthServiceApiRef);

  const handleReload = () => {
    window.localStorage.removeItem(LOCAL_STORAGE_PENDING_RELOAD_KEY);
    reloadPage();
  };

  // if navigating between pages and version is out of sync then automatically reload
  useLayoutEffect(() => {
    if (
      !location.state &&
      window.localStorage.getItem(LOCAL_STORAGE_PENDING_RELOAD_KEY)
    ) {
      handleReload();
    }
  }, [location]);

  // after idle on page for 60s, if version is out of sync then display message
  useQuery({
    queryFn: async () => {
      await health.getLiveness();
      if (
        !isAlertPosted &&
        window.localStorage.getItem(LOCAL_STORAGE_PENDING_RELOAD_KEY)
      ) {
        alerts.post({
          severity: 'info',
          display: 'transient',
          message:
            '🚀 A new Developer Portal update is live! Refresh to start using it',
        });
        setIsAlertPosted(true);
      }
      return null;
    },
    queryKey: [],
    cacheTime: 0,
    refetchInterval: isAlertPosted ? false : 60000,
    refetchIntervalInBackground: true,
    retry: false,
  });
};
